// extracted by mini-css-extract-plugin
export default {"secondaryButton":"style_secondaryButton__C4Tf8","scalableSecondaryButton":"style_scalableSecondaryButton__4es2k","childrenWrapper":"style_childrenWrapper__KAoJJ"};